export default __webpack_public_path__ + "locales/pl/InviteDialog.json?hash=cf5cedcc38a90b2836e39d4616820229";